<template>
	<div class="redirect-page">
		<Loader size_prop="10em"></Loader>
	</div>
</template>

<script>
import Loader from '../components/Loader.vue'

export default {
	name: 'RedirectPage',

	components: {
		Loader,
	},

	data() {
		return {
		}
	},

	created() {
		const type = this.$route.query.jfxType
		console.log('REDIRECT', this.$route, this.$route.query)

		switch (type) {
			case 'iframeTransaction': {
				const parentOrigin = window.location.origin

				const status_code = this.$route.query.status_code
				// midtrans times up
				if (status_code == 407) {
					window.parent.postMessage(
						{ message: 'goToTradeTicket' },
						parentOrigin // always specify exact target origin
					)
				} else {
					window.parent.postMessage(
						{ message: 'goToTransaction' },
						parentOrigin // always specify exact target origin
					)
				}
				break
			}

			case 'gopayPayment': {
				const status_code = this.$route.query.status_code
				const jfxStatus = this.$route.query.jfxStatus || 'success'

				console.log('status_code REDIRECT', status_code, jfxStatus)

				// midtrans times up or error
				if (status_code == 407 || jfxStatus == 'error') {
					this.$router.push({ name: 'Trade' })
				} else {
					this.$store.commit('setReportToShow_mut', 'transactions')
					this.$router.push({ name: 'Reports' })
				}
				break
			}

			default: break
		}
	},
}
</script>

<style scoped>
.redirect-page {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100vh;
}
</style>